// EARNINGS_SURPRISE widget - maps to data-provider/source/instructions/EARNINGS_SURPRISE
import type { RangeOption } from '../../../blocks/chart-widget';

export type EarningsSurpriseChartRange = '1Y' | '2Y' | '3Y' | 'ALL';

// Quarterly cadence: ranges slice by trailing quarter count.
export const EARNINGS_SURPRISE_RANGE_OPTIONS: Array<RangeOption & { value: EarningsSurpriseChartRange }> = [
  { value: '1Y', label: '1Y', rows: 4 },
  { value: '2Y', label: '2Y', rows: 8 },
  { value: '3Y', label: '3Y', rows: 12 },
  { value: 'ALL', label: 'All' },
];

export interface EarningsSurpriseWidgetConfig {
  /** Initially selected chart range (user can change it on the widget). */
  defaultRange?: EarningsSurpriseChartRange;
}

export interface EarningsSurpriseWidgetInstanceConfig extends EarningsSurpriseWidgetConfig {
  dataKey?: string;
}

export interface EarningsSurpriseRow {
  date: string;
  label: string | null;
  actual: number | null;
  estimate: number | null;
  surprise_pct: number | null;
}

export interface EarningsSurpriseData {
  ticker: string;
  last_period: string | null;
  last_actual_eps: number | null;
  last_estimate_eps: number | null;
  last_surprise_pct: number | null;
  surprise_history: EarningsSurpriseRow[] | null;
}
